// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../assets/images/banner/lady-one.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../../assets/images/alternative_images/machine-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../../assets/images/alternative_images/baby.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../../assets/images/alternative_images/headset.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../../assets/images/alternative_images/shirt.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../../assets/images/alternative_images/lips.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner {
  width: 100%;
}

.promo-section {
  padding: 0% 10% !important;
}

.shimmer-container {
  padding: 0% 10% !important;
}

.flyer {
  height: auto;
  width: 100%;
  object-fit: cover;
  margin-top: 5%;
  border-radius: 45px;
}

#banner-section {
  width: 100% !important;
  padding: 0px 10%;
}

.download-btn .download-btn-text {
  font-size: 13.5px !important;
}

.download-btn {
  border-radius: 40px !important;
}

.floating-btn-home {
  margin-left: -8%;
  z-index: 1;
  bottom: 0;
  margin-bottom: 2%;
  transition: transform 0.5s ease-in-out;
  animation: bounce 1.5s infinite;
  /* From https://css.glass */
}

.btn-glass {
  background: rgba(255, 255, 255, 0.13);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5.5px);
  -webkit-backdrop-filter: blur(5.5px);
}

.floating-btn-home:hover {
  animation: bounce 1.5s infinite;
}

.banner-try {
  background: transparent linear-gradient(6deg, #7062f9 0%, #8d81fa 100%) 0% 0% no-repeat padding-box;
  border-radius: 45px;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  width: 100%;
  height: auto;
}

.floating-btn {
  margin-left: -8%;
  bottom: 0;
  margin-bottom: 5%;
}

.banner-col-1-text {
  font-size: 50px;
  line-height: 45px;
  padding-bottom: 15px;
}

.background-image-col-home {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  width: 600px;
  height: 100%;
  position: absolute;
  margin-left: 2%;
  margin-top: 11%;
}

.card-on-hover {
  width: 200px;
  height: 210px;
  border-radius: 30px;
  margin-top: -10% !important;
}

.orange-spot {
  height: 10px;
  background: salmon;
}

.spot {
  position: absolute;
  margin-top: -10% !important;
  background: salmon;
}

.alternating-images-on-hover-home {
  width: 150px !important;
  height: 200px !important;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  position: absolute;
  left: 0% !important;
  margin-top: -50% !important;
  animation: imageSwap 30s infinite;
}

@keyframes imageSwap {
  100% {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  10% {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
  20% {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }
  30% {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  }
  40% {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  }
}
@media only screen and (max-width: 1399px) {
  .background-image-col-home {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: contain;
    width: 600px;
    height: 100%;
    position: absolute;
    margin-left: -18% !important;
    margin-top: 15% !important;
  }
  .card-on-hover {
    margin-top: -17% !important;
    margin-left: 10% !important;
  }
  .download-btn {
    font-size: 12px !important;
  }
}
@media only screen and (max-width: 1899px) {
  .background-image-col-home {
    margin-top: 11.5% !important;
  }
}
@media only screen and (max-width: 1799px) {
  .background-image-col-home {
    margin-top: 12% !important;
  }
}
@media only screen and (max-width: 1699px) {
  .background-image-col-home {
    margin-top: 13.5% !important;
  }
}
@media only screen and (max-width: 1599px) {
  .background-image-col-home {
    margin-top: 14% !important;
  }
}
@media only screen and (max-width: 1499px) {
  .background-image-col-home {
    margin-top: 15% !important;
  }
}
@media only screen and (max-width: 1299px) {
  .background-image-col-home {
    margin-top: 16.5% !important;
  }
}
@media only screen and (max-width: 1230px) {
  .background-image-col-home {
    margin-top: 17.5% !important;
  }
}
@media only screen and (max-width: 1209px) {
  .background-image-col-home {
    margin-top: 28.5% !important;
  }
}
@media only screen and (max-width: 1199px) {
  .background-image-col-home {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: contain;
    width: 600px;
    height: 100%;
    position: absolute;
    margin-left: -16% !important;
    margin-top: 12.5% !important;
  }
  .card-on-hover {
    margin-top: -10% !important;
    margin-left: 15% !important;
  }
  .download-btn {
    font-size: 12px !important;
  }
  .banner-try .banner-col-1 {
    width: 100% !important;
  }
  .banner-col-1-text {
    font-size: 30px !important;
    line-height: 20px;
  }
  .btn-section {
    display: inline !important;
  }
}
@media only screen and (max-width: 1130px) {
  .background-image-col-home {
    background-image: none !important;
  }
  .card-on-hover {
    margin-top: 10% !important;
    left: 15% !important;
  }
}
@media only screen and (max-width: 1099px) {
  .background-image-col-home {
    margin-top: 13.5% !important;
    margin-left: -25% !important;
  }
  .card-on-hover {
    top: 20% !important;
    left: -15% !important;
  }
}
@media only screen and (max-width: 1030px) {
  .background-image-col-home {
    margin-top: 15.5% !important;
    margin-left: -85% !important;
  }
}
@media only screen and (max-width: 991px) {
  .background-image-col-home {
    background-image: none !important;
    width: 0px !important;
    height: 100%;
    margin-top: 15.5% !important;
    margin-left: -115% !important;
  }
  .banner-try {
    padding: 0 !important;
    margin-bottom: 15% !important;
  }
  .card-on-hover {
    top: -7% !important;
    left: -25% !important;
  }
  .download-btn {
    padding: 15px 15px !important;
    margin: 10px 0px !important;
  }
}
@media only screen and (max-width: 950px) {
  .background-image-col-home {
    margin-top: 15.5% !important;
    margin-left: -155% !important;
  }
}
@media only screen and (max-width: 930px) {
  .background-image-col-home {
    top: 11.5%;
    margin-left: -165% !important;
  }
}
@media only screen and (max-width: 910px) {
  .background-image-col-home {
    margin-top: 15.5% !important;
    margin-left: -165% !important;
  }
}
@media only screen and (max-width: 899px) {
  .background-image-col-home {
    margin-top: 5.5% !important;
    margin-left: -205% !important;
  }
  .floating-btn-home {
    margin-left: -2%;
  }
}
@media only screen and (max-width: 875px) {
  .background-image-col-home {
    margin-top: 5.5% !important;
    margin-left: -255% !important;
  }
  .floating-btn-home {
    margin-left: -2%;
  }
}
@media only screen and (max-width: 852px) {
  .background-image-col-home {
    margin-top: 5.5% !important;
    margin-left: -305% !important;
  }
}
@media only screen and (max-width: 841px) {
  .background-image-col-home {
    margin-top: 5.5% !important;
    margin-left: -355% !important;
  }
}
@media only screen and (max-width: 829px) {
  .background-image-col-home {
    margin-top: 5.5% !important;
    margin-left: -420% !important;
  }
}
@media only screen and (max-width: 816px) {
  .background-image-col-home {
    margin-top: 5.5% !important;
    margin-left: -480% !important;
  }
}
@media only screen and (max-width: 799px) {
  .card-on-hover {
    top: 10% !important;
    left: -45% !important;
  }
  .background-image-col-home {
    margin-top: -65.5% !important;
    margin-left: -680% !important;
  }
}
@media only screen and (max-width: 790px) {
  .background-image-col-home {
    margin-top: -65.5% !important;
    margin-left: -760% !important;
  }
}
@media only screen and (max-width: 780px) {
  .background-image-col-home {
    margin-top: -65.5% !important;
    margin-left: -1020% !important;
  }
}
@media only screen and (max-width: 774px) {
  .background-image-col-home {
    margin-top: -45.5% !important;
    left: 1080% !important;
  }
}
@media only screen and (max-width: 767px) {
  .background-image-col-home {
    background-image: none !important;
    background-color: white;
    min-width: 100% !important;
  }
  .banner-col-2 {
    min-width: 100% !important;
    background: #fcf8f8 !important;
    display: none !important;
  }
  .spot {
    position: relative !important;
    margin-top: -10% !important;
    background: none !important;
  }
  .banner-try {
    padding: 0 !important;
    margin-bottom: 15% !important;
    background: transparent linear-gradient(6deg, #7062f9 0%, #8d81fa 100%) 0% 0% no-repeat padding-box;
    border-radius: 45px;
    animation: gradient 15s ease infinite;
    height: 100%;
    margin: 0% 0.5% !important;
  }
  @keyframes gradient {
    0%, 100% {
      background-size: 200% 100%;
      background-position: 100% 50%;
    }
    50% {
      background-size: 200% 100%;
      background-position: 0% 50%;
    }
  }
  .card-on-hover {
    margin-top: 0% !important;
    margin-left: 0% !important;
    height: 100% !important;
    position: relative !important;
  }
  .floating-btn {
    margin-left: 0% !important;
    bottom: 0;
    margin-bottom: 2% !important;
  }
  .download-btn {
    padding: 15px 15px !important;
    margin: 10px 0px !important;
    font-size: 12px !important;
  }
  .banner-col-1 {
    text-align: center;
  }
  .banner-col-1-text {
    width: 100vw !important;
    margin: 0% 0% !important;
  }
  .banner-section {
    padding: 10px !important;
  }
}
@media only screen and (max-width: 620px) {
  .promo-section {
    padding: 0% 0% !important;
  }
  .shimmer-container {
    padding: 0% 0% !important;
  }
  #banner-section {
    width: 100% !important;
    padding: 0px 0% !important;
  }
  .banner-try {
    border-radius: 0% !important;
    padding: 0% !important;
    margin: 0% !important;
    width: 100% !important;
  }
  .banner-col-1 .banner-col-1-text {
    font-size: 40px !important;
  }
}
@media only screen and (max-width: 500px) {
  .banner-col-1 .banner-col-1-text {
    font-size: 30px !important;
  }
}
@media only screen and (max-width: 430px) {
  .banner-col-1 .banner-col-1-text {
    font-size: 30px !important;
  }
  .scroll-down-to-section {
    margin-bottom: 30px !important;
  }
  .text-link {
    margin-bottom: 50px !important;
  }
}
@media only screen and (max-width: 350px) {
  .banner-col-1 .banner-col-1-text {
    font-size: 25px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/presentation/main/home/components/banner/banner.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACA,sBAAA;EACA,gBAAA;AACA;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAKA;EAEE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,sCAAA;EACA,+BAAA;EACA,2BAAA;AAHF;;AAQA;EACE,qCAAA;EACA,mBAAA;EACA,yCAAA;EACA,4BAAA;EACA,oCAAA;AALF;;AASA;EACA,+BAAA;AANA;;AASA;EACE,mGAAA;EAEA,mBAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EAEA,WAAA;EACA,YAAA;AARF;;AAsBA;EACE,gBAAA;EACA,SAAA;EACA,iBAAA;AAnBF;;AAsBA;EACE,eAAA;EACA,iBAAA;EACA,oBAAA;AAnBF;;AAuBA;EACG,yDAAA;EACD,4BAAA;EACA,wBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AApBF;;AA6BA;EACE,YAAA;EACF,aAAA;EACA,mBAAA;EACA,2BAAA;AA1BA;;AA6BA;EAEE,YAAA;EACA,kBAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,2BAAA;EACA,kBAAA;AA3BF;;AA8BA;EAEE,uBAAA;EACA,wBAAA;EACA,2BAAA;EACA,sBAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,iCAAA;AA5BF;;AA+BA;EACE;IACE,yDAAA;EA5BF;EA8BA;IACE,yDAAA;EA5BF;EA8BA;IACE,yDAAA;EA5BF;EA8BA;IACE,yDAAA;EA5BF;EA8BA;IACE,yDAAA;EA5BF;AACF;AAiCA;EACA;IACG,yDAAA;IACA,4BAAA;IACA,wBAAA;IACA,YAAA;IACA,YAAA;IACA,kBAAA;IACA,4BAAA;IACA,0BAAA;EA/BD;EAkCF;IACA,2BAAA;IACA,2BAAA;EAhCE;EAmCF;IACA,0BAAA;EAjCE;AACF;AA4CA;EACE;IACC,4BAAA;EA1CD;AACF;AA8CA;EACE;IACC,0BAAA;EA5CD;AACF;AAgDA;EACE;IACC,4BAAA;EA9CD;AACF;AAkDA;EACE;IACC,0BAAA;EAhDD;AACF;AAoDA;EACE;IACC,0BAAA;EAlDD;AACF;AAsDA;EACE;IACC,4BAAA;EApDD;AACF;AAwDA;EACE;IACC,4BAAA;EAtDD;AACF;AAyDA;EACE;IACC,4BAAA;EAvDD;AACF;AA0DA;EACE;IACE,yDAAA;IACD,4BAAA;IACA,wBAAA;IACA,YAAA;IACA,YAAA;IACA,kBAAA;IACA,4BAAA;IACA,4BAAA;EAxDD;EA2DD;IACD,2BAAA;IACA,2BAAA;EAzDE;EA4DF;IACA,0BAAA;EA1DE;EA6DD;IACC,sBAAA;EA3DA;EA8DD;IACC,0BAAA;IACA,iBAAA;EA5DA;EA8DF;IACE,0BAAA;EA5DA;AACF;AAgEA;EACE;IACE,iCAAA;EA9DF;EAkED;IACD,0BAAA;IACA,oBAAA;EAhEE;AACF;AAoEA;EACE;IACC,4BAAA;IACA,4BAAA;EAlED;EAoED;IACC,mBAAA;IACA,qBAAA;EAlEA;AACF;AAqEA;EACE;IACC,4BAAA;IACA,4BAAA;EAnED;AACF;AA4EA;EACE;IACA,iCAAA;IACC,qBAAA;IACA,YAAA;IACC,4BAAA;IACA,6BAAA;EA1EF;EA8ED;IACC,qBAAA;IACA,6BAAA;EA5EA;EAgFD;IACC,mBAAA;IACA,qBAAA;EA9EA;EAkFF;IACE,6BAAA;IACA,2BAAA;EAhFA;AACF;AAoFA;EACE;IACI,4BAAA;IACA,6BAAA;EAlFJ;AACF;AAsFA;EACE;IACI,UAAA;IACA,6BAAA;EApFJ;AACF;AAyFA;EACE;IACI,4BAAA;IACA,6BAAA;EAvFJ;AACF;AA6FA;EAEE;IACE,2BAAA;IACA,6BAAA;EA5FF;EA+FD;IAEC,gBAAA;EA9FA;AACF;AAmGA;EAEE;IACE,2BAAA;IACA,6BAAA;EAlGF;EAqGD;IACC,gBAAA;EAnGA;AACF;AAwGA;EAEE;IACE,2BAAA;IACA,6BAAA;EAvGF;AACF;AA2GA;EAEE;IACE,2BAAA;IACA,6BAAA;EA1GF;AACF;AA8GA;EAEE;IACE,2BAAA;IACA,6BAAA;EA7GF;AACF;AAiHA;EAEE;IACE,2BAAA;IACA,6BAAA;EAhHF;AACF;AAuHA;EACE;IACE,mBAAA;IACA,qBAAA;EArHF;EAwHE;IACE,6BAAA;IACA,6BAAA;EAtHJ;AACF;AA4HA;EAGI;IACE,6BAAA;IACA,6BAAA;EA5HJ;AACF;AAiIA;EAGE;IACE,6BAAA;IACA,8BAAA;EAjIF;AACF;AAsIA;EACI;IACE,6BAAA;IACA,sBAAA;EApIJ;AACF;AAyIA;EACE;IACA,iCAAA;IACA,uBAAA;IACA,0BAAA;EAvIA;EA2ID;IACC,0BAAA;IACA,8BAAA;IACA,wBAAA;EAzIA;EA2ID;IACC,6BAAA;IACA,2BAAA;IACA,2BAAA;EAzIA;EA6ID;IACC,qBAAA;IACA,6BAAA;IACA,mGAAA;IACA,mBAAA;IACA,qCAAA;IACA,YAAA;IACA,0BAAA;EA3IA;EAgJD;IACC;MACE,0BAAA;MACA,6BAAA;IA9IA;IAgJF;MACE,0BAAA;MACA,2BAAA;IA9IA;EACF;EAmJD;IACD,yBAAA;IACA,0BAAA;IACA,uBAAA;IACA,6BAAA;EAjJE;EAoJF;IACE,0BAAA;IACA,SAAA;IACA,4BAAA;EAlJA;EAqJF;IACE,6BAAA;IACA,2BAAA;IACA,0BAAA;EAnJA;EAuJC;IAEC,kBAAA;EAtJF;EAyJC;IACC,uBAAA;IACA,wBAAA;EAvJF;EA2JC;IACC,wBAAA;EAzJF;AACF;AA6JA;EACE;IACE,yBAAA;EA3JF;EA8JA;IACE,yBAAA;EA5JF;EA+JA;IACE,sBAAA;IACA,0BAAA;EA7JF;EAgKE;IACE,4BAAA;IACA,sBAAA;IACA,qBAAA;IACA,sBAAA;EA9JJ;EAkKI;IACE,0BAAA;EAhKN;AACF;AAoKA;EAEI;IACE,0BAAA;EAnKJ;AACF;AAyKA;EAEI;IACE,0BAAA;EAxKJ;EA2KA;IACC,8BAAA;EAzKD;EA4KA;IACE,8BAAA;EA1KF;AACF;AA8KA;EAEI;IACE,0BAAA;EA7KJ;AACF","sourcesContent":[".banner{\n  width: 100%;\n}\n\n.promo-section{\n  padding:0% 10% !important;\n}\n\n.shimmer-container{\n  padding:0% 10% !important;\n}\n\n.flyer{\n  height:auto;\n  width:100%;\n  object-fit: cover;\n  margin-top:5%;\n  border-radius:45px;\n}\n\n#banner-section{\nwidth: 100% !important;\npadding:0px 10%;\n}\n\n.download-btn .download-btn-text{\n  font-size:13.5px !important;\n }\n\n.download-btn{\n  border-radius:40px !important;\n   }\n\n\n  \n\n.floating-btn-home{\n  // position:absolute;\n  margin-left:-8%;\n  z-index:1;\n  bottom:0;\n  margin-bottom:2%;\n  transition: transform 0.5s ease-in-out;\n  animation: bounce 1.5s infinite;\n  /* From https://css.glass */\n\n}\n\n\n.btn-glass{\n  background: rgba(255, 255, 255, 0.13);\n  border-radius: 16px;\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(5.5px);\n  -webkit-backdrop-filter: blur(5.5px);\n \n}\n\n.floating-btn-home:hover{\nanimation: bounce 1.5s infinite;\n}\n\n.banner-try{\n  background: transparent linear-gradient(6deg, #7062f9 0%, #8d81fa 100%) 0% 0% no-repeat padding-box;\n  // background-image: url(\"../../../../../assets/video/homebg.gif\");\n  border-radius: 45px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  width:100%;\n  // animation: gradient 15s ease infinite;\n  width: 100%;\n  height: auto;\n}\n// @keyframes gradient {\n//   0%, 100% {\n//     background-size: 200% 100%;\n//     background-position: 100% 50%;\n//   }\n//   50% {\n//     background-size: 200% 100%;\n//     background-position: 0% 50%;\n//   }\n// }\n\n\n.floating-btn {\n  margin-left: -8%;\n  bottom: 0;\n  margin-bottom: 5%;\n}\n\n.banner-col-1-text {\n  font-size: 50px;\n  line-height: 45px;\n  padding-bottom:15px;\n}\n\n\n.background-image-col-home{\n   background-image: url(\"../../../../../assets/images/banner/lady-one.png\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  width:600px;\n  height:100%;\n  position:absolute;\n  margin-left:2%;\n  margin-top:11%;\n\n  // position:absolute;\n}\n\n.redirect-link{\n  \n}\n\n.card-on-hover{\n  width: 200px;\nheight: 210px;\nborder-radius: 30px;\nmargin-top:-10% !important;\n}\n\n.orange-spot {\n  // width: 10px;\n  height: 10px;\n  background: salmon;\n}\n\n.spot{\n  position:absolute;\n  margin-top:-10% !important;\n  background: salmon;\n}\n\n.alternating-images-on-hover-home {\n  // background-image: url(\"../../../../../assets/images/banner/blue-bag.png\");\n  width: 150px !important;\n  height: 200px !important;\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: absolute;\n  left: 0% !important;\n  margin-top:-50% !important;\n  animation: imageSwap 30s infinite;\n}\n\n@keyframes imageSwap {\n  100% {\n    background-image: url(\"../../../../../assets/images/alternative_images/machine-1.png\");\n  }\n  10% {\n    background-image: url(\"../../../../../assets/images/alternative_images/baby.png\");\n  }\n  20% {\n    background-image: url(\"../../../../../assets/images/alternative_images/headset.png\");\n  }\n  30% {\n    background-image: url(\"../../../../../assets/images/alternative_images/shirt.png\");\n  }\n  40% {\n    background-image: url(\"../../../../../assets/images/alternative_images/lips.png\");\n  }\n}\n\n\n\n@media only screen and (max-width: 1399px) {\n.background-image-col-home{\n   background-image: url(\"../../../../../assets/images/banner/lady-one.png\");\n   background-repeat: no-repeat;\n   background-size: contain;\n   width:600px;\n   height:100%;\n   position:absolute;\n   margin-left:-18% !important;\n   margin-top:15% !important;\n }\n\n.card-on-hover{\nmargin-top:-17% !important;\nmargin-left: 10% !important;\n}\n\n.download-btn{\nfont-size:12px !important;\n}\n\n\n}\n\n\n\n\n\n\n\n@media only screen and (max-width: 1899px) {\n  .background-image-col-home{\n   margin-top:11.5% !important;\n\n }\n}\n\n@media only screen and (max-width: 1799px) {\n  .background-image-col-home{\n   margin-top:12% !important;\n\n }\n}\n\n@media only screen and (max-width: 1699px) {\n  .background-image-col-home{\n   margin-top:13.5% !important;\n\n }\n}\n\n@media only screen and (max-width: 1599px) {\n  .background-image-col-home{\n   margin-top:14% !important;\n\n }\n}\n\n@media only screen and (max-width: 1499px) {\n  .background-image-col-home{\n   margin-top:15% !important;\n\n }\n}\n\n@media only screen and (max-width: 1299px) {\n  .background-image-col-home{\n   margin-top:16.5% !important;\n\n }\n}\n\n@media only screen and (max-width: 1230px) {\n  .background-image-col-home{\n   margin-top:17.5% !important;\n }\n}\n\n@media only screen and (max-width: 1209px) {\n  .background-image-col-home{\n   margin-top:28.5% !important;\n }\n}\n\n@media only screen and (max-width: 1199px) {\n  .background-image-col-home{\n    background-image: url(\"../../../../../assets/images/banner/lady-one.png\");\n   background-repeat: no-repeat;\n   background-size: contain;\n   width:600px;\n   height:100%;\n   position:absolute;\n   margin-left:-16% !important;\n   margin-top:12.5% !important;\n   // position:absolute;\n }\n .card-on-hover{\nmargin-top:-10% !important;\nmargin-left: 15% !important;\n}\n\n.download-btn{\nfont-size:12px !important;\n }\n\n .banner-try .banner-col-1 {\n  width: 100%  !important;\n }\n\n .banner-col-1-text {\n  font-size: 30px !important;\n  line-height: 20px;\n }\n.btn-section{\n  display: inline !important;\n}\n\n}\n\n@media only screen and (max-width: 1130px) {\n  .background-image-col-home{\n    background-image:none !important;\n   // position:absolute;\n }\n\n .card-on-hover{\nmargin-top:10% !important;\nleft: 15% !important;\n}\n\n}\n\n@media only screen and (max-width: 1099px) {\n  .background-image-col-home{\n   margin-top:13.5% !important;\n   margin-left: -25% !important;\n }\n .card-on-hover{\n  top:20% !important;\n  left: -15% !important;\n  }\n}\n\n@media only screen and (max-width: 1030px) {\n  .background-image-col-home{\n   margin-top:15.5% !important;\n   margin-left: -85% !important;\n }\n\n//  .card-on-hover{\n//   margin-top:-3% !important;\n//   left: -30% !important;\n//   }\n  \n}\n\n@media only screen and (max-width: 991px) {\n  .background-image-col-home{\n  background-image: none !important;\n   width:0px !important;\n   height:100%;\n    margin-top:15.5% !important;\n    margin-left: -115% !important;\n }\n\n\n .banner-try{\n  padding:0 !important;\n  margin-bottom:15% !important;\n }\n\n\n .card-on-hover{\n  top:-7% !important;\n  left: -25% !important;\n  }\n\n\n.download-btn{\n  padding: 15px 15px !important;\n  margin:10px 0px !important;\n}\n}\n\n\n@media only screen and (max-width: 950px) {\n  .background-image-col-home{\n      margin-top:15.5% !important;\n      margin-left: -155% !important;\n   }\n  \n}\n\n@media only screen and (max-width: 930px) {\n  .background-image-col-home{\n      top:11.5% ;\n      margin-left: -165% !important;\n   }\n  \n}\n\n\n@media only screen and (max-width: 910px) {\n  .background-image-col-home{\n      margin-top:15.5% !important;\n      margin-left: -165% !important;\n   }\n  \n}\n\n\n\n@media only screen and (max-width: 899px) {\n\n  .background-image-col-home{\n    margin-top:5.5% !important;\n    margin-left: -205% !important;\n }\n    \n .floating-btn-home{\n  // position:absolute;\n  margin-left:-2% ;\n}\n\n\n}\n\n@media only screen and (max-width: 875px) {\n\n  .background-image-col-home{\n    margin-top:5.5% !important;\n    margin-left: -255% !important;\n }\n    \n .floating-btn-home{\n  margin-left:-2% ;\n}\n\n\n}\n\n@media only screen and (max-width: 852px) {\n\n  .background-image-col-home{\n    margin-top:5.5% !important;\n    margin-left: -305% !important;\n }\n    \n}\n\n@media only screen and (max-width: 841px) {\n\n  .background-image-col-home{\n    margin-top:5.5% !important;\n    margin-left: -355% !important;\n }\n    \n}\n\n@media only screen and (max-width: 829px) {\n\n  .background-image-col-home{\n    margin-top:5.5% !important;\n    margin-left: -420% !important;\n }\n    \n}\n\n@media only screen and (max-width: 816px) {\n\n  .background-image-col-home{\n    margin-top:5.5% !important;\n    margin-left: -480% !important;\n }\n    \n}\n\n\n\n\n@media only screen and (max-width: 799px) {\n  .card-on-hover{ \n    top:10% !important;\n    left: -45% !important;\n    }\n\n    .background-image-col-home{\n      margin-top:-65.5% !important;\n      margin-left: -680% !important;\n   }\n      \n    \n}\n\n\n@media only screen and (max-width: 790px) {\n  \n\n    .background-image-col-home{\n      margin-top:-65.5% !important;\n      margin-left: -760% !important;\n   }\n      \n    \n}\n\n@media only screen and (max-width: 780px) {\n  \n\n  .background-image-col-home{\n    margin-top:-65.5% !important;\n    margin-left: -1020% !important;\n }\n    \n  \n}\n\n@media only screen and (max-width: 774px) {\n    .background-image-col-home{\n      margin-top:-45.5% !important;\n      left: 1080% !important;\n   }\n}\n\n\n\n@media only screen and (max-width: 767px) {\n  .background-image-col-home{\n  background-image: none !important;\n  background-color: white;\n  min-width:100% !important;\n\n }\n\n .banner-col-2{\n  min-width:100% !important;\n  background: #fcf8f8  !important;\n  display: none !important;\n }\n .spot{\n  position:relative !important;\n  margin-top:-10% !important;\n  background: none !important;\n}\n\n\n .banner-try{\n  padding:0 !important;\n  margin-bottom:15% !important;\n  background: transparent linear-gradient(6deg, #7062f9 0%, #8d81fa 100%) 0% 0% no-repeat padding-box;\n  border-radius: 45px;\n  animation: gradient 15s ease infinite;\n  height: 100%;\n  margin:0% 0.5% !important  \n\n }\n\n\n @keyframes gradient {\n  0%, 100% {\n    background-size: 200% 100%;\n    background-position: 100% 50%;\n  }\n  50% {\n    background-size: 200% 100%;\n    background-position: 0% 50%;\n  }\n}\n\n\n\n .card-on-hover{\nmargin-top:0% !important;\nmargin-left: 0% !important;\nheight: 100% !important;\nposition: relative !important;\n}\n\n.floating-btn {\n  margin-left: 0% !important;\n  bottom: 0;\n  margin-bottom: 2% !important;\n}\n\n.download-btn{\n  padding: 15px 15px !important;\n  margin:10px 0px !important;\n  font-size:12px !important;\n   }\n\n\n   .banner-col-1{\n// min-width:100% !important;\n    text-align: center;\n   }\n\n   .banner-col-1-text{\n    width:100vw !important;\n    margin: 0% 0% !important;\n    // font-size:30px !important;\n   }\n\n   .banner-section{\n    padding:10px !important;\n   }\n\n}\n\n@media only screen and (max-width: 620px) {\n  .promo-section{\n    padding:0% 0% !important;\n  }\n  \n  .shimmer-container{\n    padding:0% 0% !important;\n  }\n  \n  #banner-section{\n    width: 100% !important;\n    padding:0px 0% !important;\n    }\n\n    .banner-try{\n      border-radius: 0% !important;\n      padding:0% !important;\n      margin:0% !important;\n      width: 100% !important;\n    }\n\n    .banner-col-1{\n      .banner-col-1-text {\n        font-size:40px !important;\n      }\n    }\n}\n\n@media only screen and (max-width: 500px) {\n  .banner-col-1{\n    .banner-col-1-text {\n      font-size:30px !important;\n    }\n  }\n    \n}\n\n\n@media only screen and (max-width: 430px) {\n  .banner-col-1{\n    .banner-col-1-text {\n      font-size:30px !important;\n    }\n  }\n  .scroll-down-to-section{\n   margin-bottom: 30px !important;\n  }\n    \n  .text-link{\n    margin-bottom: 50px !important;\n  }\n}\n\n\n@media only screen and (max-width: 350px) {\n  .banner-col-1{\n    .banner-col-1-text {\n      font-size:25px !important;\n    }\n  }\n    \n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
